jQuery(document).ready(function($) {

    //Submit Form
    $('#qform').submit(function(event) {

        const action_url = '/cms/wp-admin/admin-ajax.php?action=send_ctype_contact_form';
        const formData = $(this).serializeArray();

        $.ajax({
            type: 'POST',
            url: action_url,
            data: formData
        }).done(function(data) {

            let message = '';

            if (data == 'true') {
                message = '<div class="confirmation-overlay"><h2>Vielen Dank für Ihre Nachricht</h2></div>';
                $('.js-contact-form, .module-layotterheadline').hide();
            } else {
                message = '<div class="confirmation-overlay error"><p><strong>Tut uns leid, leider konnte Ihre E-Mail nicht versendet werden.</strong></p><p>Bitte versuchen Sie es noch einmal.</p></div>';
            }

            $('.confirmation-overlay').remove();

            $('.module-singlectypecontactform').append(message);


            $('html, body').animate({
                scrollTop: $(".confirmation-overlay").offset().top - 150
            }, 800);


        });
        event.preventDefault();
    });


});
